import { render, staticRenderFns } from "./examinetask.vue?vue&type=template&id=c6342e74&"
import script from "./examinetask.vue?vue&type=script&lang=js&"
export * from "./examinetask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports